import { useGetPools } from 'clients/api';
import { VIP_PORTFOLIO_THRESHOLD_CENTS } from 'constants/vip';
import { useAccountAddress } from 'libs/wallet';

export const useIsConnectedAccountVip = () => {
  const { accountAddress } = useAccountAddress();

  const { data: getPoolsData } = useGetPools({
    accountAddress,
  });

  const portfolioValueCents = (getPoolsData?.pools ?? []).reduce((acc, pool) => {
    let poolPortfolioValueCents = 0;

    pool.assets.forEach(asset => {
      poolPortfolioValueCents +=
        asset.userSupplyBalanceCents.toNumber() + asset.userBorrowBalanceCents.toNumber();
    });

    return acc + poolPortfolioValueCents;
  }, 0);

  const isConnectedAccountVip = portfolioValueCents >= VIP_PORTFOLIO_THRESHOLD_CENTS;

  return {
    isConnectedAccountVip,
  };
};
